export default __webpack_public_path__ + "locales/ru/MainBar.json?hash=cca3e09ff5014468085246a94fc1b766";